import { render, staticRenderFns } from "./EditTable.vue?vue&type=template&id=efb5ce14"
import script from "./EditTable.vue?vue&type=script&lang=ts"
export * from "./EditTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports